import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-panel" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "position-relative" }
const _hoisted_4 = { class: "d-flex login-panel" }
const _hoisted_5 = { class: "d-flex flex-column login-content" }
const _hoisted_6 = { class: "d-flex flex-column login-form" }
const _hoisted_7 = { class: "d-flex flex-column form-item-panel" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex flex-column form-item-panel" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = { class: "w-100 buttons" }
const _hoisted_13 = { class: "d-flex w-100 justify-content-center" }
const _hoisted_14 = { class: "d-flex flex-column login-content" }
const _hoisted_15 = { class: "d-flex flex-column login-form" }
const _hoisted_16 = { class: "d-flex flex-column form-item-panel" }
const _hoisted_17 = { class: "d-flex flex-column" }
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = { class: "w-100 buttons" }
const _hoisted_21 = { class: "d-flex w-100 justify-content-center" }
const _hoisted_22 = { class: "d-flex flex-column login-content" }
const _hoisted_23 = { class: "d-flex flex-column login-form" }
const _hoisted_24 = { class: "d-flex flex-column form-item-panel" }
const _hoisted_25 = { class: "d-flex flex-column" }
const _hoisted_26 = { class: "invalid-feedback" }
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = { class: "d-flex flex-column form-item-panel" }
const _hoisted_29 = { class: "d-flex flex-column" }
const _hoisted_30 = { class: "d-flex flex-column login-content" }
const _hoisted_31 = { class: "d-flex flex-column login-form" }
const _hoisted_32 = { class: "d-flex flex-column form-item-panel" }
const _hoisted_33 = { class: "d-flex flex-column" }
const _hoisted_34 = { class: "invalid-feedback" }

import {computed, reactive, ref} from 'vue'

import {useMainStore} from "@/stores/mainStore";
import useVuelidate from '@vuelidate/core';
import {email, minLength, required, sameAs} from '@vuelidate/validators';
import api from '@/http/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginModal',
  setup(__props) {

const data = ref<any>({username: '', password: '', remember: false})
const passwordData = ref<any>({password: '', confirmPassword: '', code: ''})
const recoverData = ref<any>({email: ''})
const recoverCodeData = ref<any>({code: ''})

const state = reactive({
    recoverMode: false,
    recoverCodeMode: false,
    changePasswordMode: false
})

const mainStore = useMainStore();

function close() {
    // console.log('calling close')
    mainStore.showLogin(false)
}

function loginHandler() {
    v$.value.$touch();
    if (v$.value.$invalid) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'Form data error!',
        })
        return
    }

    mainStore.showMask(true);
    const formData = new FormData();
    formData.append('username', data.value.username);
    formData.append('password', data.value.password);
    if (data.value.remember) {
        formData.append('remember-me', 'true');
    }
    /*const tokenElement = document.getElementById('token_element');
    if(tokenElement) {
        formData.append(tokenElement.name, tokenElement.value);
    }*/

    api.post('/login', formData)
        .then((/*response*/) => {
            // console.debug('login response: %o', response)
            mainStore.loadWhoAmI();
            mainStore.showLogin(false)
        })
        .catch(error => {
            // console.error('login error: %o', error)
            const message = error.response?.data?.exception ?? undefined;
            mainStore.showAlert({
                type: 'error',
                message: 'Login error!',
                helpText: message
            })
        })
        .finally(() => {
            mainStore.showMask(false);
        })
}

function sendRecoverHandler() {
    vRecover$.value.$touch();

    if (vRecover$.value.$invalid) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'Form data error!',
        })
        return
    }
    mainStore.showMask(true);

    api.post('/recover-password', {...recoverData.value})
        .then((/*response*/) => {
            // console.debug('recover response: ', response)
            mainStore.showAlert({
                type: 'success',
                message: 'Password recovery email sent!',
            });
            cleanFormHandler();
            state.recoverCodeMode = true;
        })
        .catch((error) => {
            if (error.status === 500) {
                mainStore.showAlert({
                    type: 'error',
                    message: 'User not found in the system!',
                });
            } else {
                mainStore.showAlert({
                    type: 'error',
                    message: 'Password recovery error!',
                });
            }
        })
        .finally(() => {
            mainStore.showMask(false);
        })

}

function sendRecoverCodeHandler() {
    // console.debug('sendRecoverCodeHandler')
    vCode$.value.$touch();
    if (vCode$.value.$invalid) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'Form data error!',
        })
        return
    }

    mainStore.showMask(true);
    api.post('/recover-password/code', {...recoverCodeData.value})
        .then(() => {
            // console.debug('sendRecoverCodeHandler response: ', response);
            passwordData.value.code = recoverCodeData.value.code;
            state.changePasswordMode = true
        })

        .catch((error) => {
            // console.error('sendRecoverCodeHandler error: ', error);
            if (error.status === 500) {
                mainStore.showAlert({
                    type: 'error',
                    message: 'Code not found in the system!',
                });
            } else {
                mainStore.showAlert({
                    type: 'error',
                    message: 'Error sending recover code!',
                })
            }
        })
        .finally(() => {
            mainStore.showMask(false);
        })
}

const submitPasswordUpdateHandler = () => {
    // console.debug('submitPasswordUpdateHandler')
    vPassword$.value.$touch();

    if (vPassword$.value.$invalid) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'Form data error!',
        })
        return
    }

    mainStore.showMask(true);
    api.post('/update-recover-password', {password: passwordData.value.password, code: passwordData.value.code})
        .then((/*response*/) => {
            // console.debug('submitPasswordUpdateHandler response: ', response);
            mainStore.showAlert({
                type: 'success',
                message: 'Password updated!',
            })
            mainStore.loadWhoAmI();
            //window.location.reload()
            mainStore.showLogin(false)
            cleanFormHandler()
        })
        .catch((/*error*/) => {
            // console.error('submitPasswordUpdateHandler error: ', error)
            mainStore.showAlert({
                type: 'error',
                message: 'Error updating password!',
            })
        })
        .finally(() => {
            mainStore.showMask(false);
        })

}

function cleanFormHandler() {
    data.value.username = '';
    data.value.password = '';
    recoverData.value.email = '';
    recoverCodeData.value.code = '';
    passwordData.value.password = '';
    passwordData.value.confirmPassword = '';
    vRecover$.value.$reset();
}

const rules = computed(() => ({
        data: {
            username: {
                required
            },
            password: {
                required
            },
        }
    })
)
const v$ = useVuelidate(rules, {data}, {$lazy: true})

const recoverRules = computed(() => ({
        recoverData: {
            email: {
                required,
                email,
            },
        }
    })
)
const vRecover$ = useVuelidate(recoverRules, {recoverData}, {$lazy: true})

const codeRules = computed(() => ({
        recoverCodeData: {
            code: {
                required,
            },
        }
    })
)
const vCode$ = useVuelidate(codeRules, {recoverCodeData}, {$lazy: true})


const passwordRules = computed(() => ({
    passwordData: {
        password: {
            required,
            minLength: minLength(8)
        },
        confirmPassword: {
            same: sameAs(passwordData.value.password)
        }
    }
}))

const vPassword$ = useVuelidate(passwordRules, {passwordData}, {$lazy: true})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "overlay",
      onClick: close
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { class: "d-flex login-header" }, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "login-header-title" }, " Contributor Log-In ", -1)),
            _createElementVNode("span", {
              class: "d-flex login-header-button pointer",
              onClick: close
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("span", { class: "material-symbols-outlined material-symbols-outlined-400 close-icon" }, " close ", -1),
              _createTextVNode(" Close ", -1)
            ]))])
          ]),
          (!state.recoverMode)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _withModifiers(loginHandler, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "login-form-label" }, "Username", -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.username) = $event)),
                          class: _normalizeClass([{'is-invalid': _unref(v$).data.username.$error}, "form-control form-control-sm"]),
                          placeholder: "Username",
                          onKeyup: _withKeys(loginHandler, ["enter"]),
                          name: "username"
                        }, null, 34), [
                          [_vModelText, data.value.username]
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "invalid-feedback" }, " Required field! ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "login-form-label" }, "Password", -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.password) = $event)),
                          type: "password",
                          onKeyup: _withKeys(loginHandler, ["enter"]),
                          class: _normalizeClass([{'is-invalid': _unref(v$).data.password.$error}, "form-control form-control-sm"]),
                          placeholder: "Password",
                          name: "password"
                        }, null, 34), [
                          [_vModelText, data.value.password]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "invalid-feedback" }, " Required field! ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["remember-form-check-input-outer", data.value.remember ? 'remember-guide-checkbox-selected' : ''])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "remember-form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.remember) = $event)),
                          id: "remember"
                        }, null, 512), [
                          [_vModelCheckbox, data.value.remember]
                        ])
                      ], 2),
                      _cache[15] || (_cache[15] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "remember"
                      }, " Remember me ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btnstyle w-100 login-button",
                      onClick: loginHandler
                    }, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                        _createElementVNode("div", { class: "button-text" }, "Login"),
                        _createElementVNode("span", { class: "material-symbols-outlined material-symbols-outlined-400 arrow-icon" }, "arrow_forward")
                      ], -1)
                    ]))]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (state.recoverMode = true)),
                        class: "btn btn-link px-0",
                        type: "button"
                      }, "Forgot password? ")
                    ])
                  ])
                ])
              ], 32))
            : (state.recoverMode && !state.recoverCodeMode && !state.changePasswordMode)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  onSubmit: _withModifiers(sendRecoverHandler, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "login-form-label" }, "Please provide an email for password recovery", -1)),
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((recoverData.value.email) = $event)),
                            placeholder: "Email",
                            class: _normalizeClass([{'is-invalid': _unref(vRecover$).recoverData.email.$error}, "form-control form-control-sm"]),
                            name: "email"
                          }, null, 2), [
                            [_vModelText, recoverData.value.email]
                          ]),
                          _withDirectives(_createElementVNode("span", _hoisted_18, " Required! ", 512), [
                            [_vShow, _unref(vRecover$).recoverData.email.required.$invalid]
                          ]),
                          _withDirectives(_createElementVNode("span", _hoisted_19, " Invalid email format! ", 512), [
                            [_vShow, _unref(vRecover$).recoverData.email.email.$invalid]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btnstyle w-100 login-button",
                        onClick: sendRecoverHandler
                      }, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                          _createElementVNode("div", { class: "button-text" }, "Send"),
                          _createElementVNode("span", { class: "material-symbols-outlined material-symbols-outlined-400 arrow-icon" }, "arrow_forward")
                        ], -1)
                      ]))]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("button", {
                          class: "btn btn-link px-0",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (state.recoverCodeMode = true)),
                          type: "button"
                        }, "I have a code ")
                      ])
                    ])
                  ])
                ], 32))
              : (state.changePasswordMode && state.recoverMode && state.recoverCodeMode)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 2,
                    onSubmit: _withModifiers(submitPasswordUpdateHandler, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "login-form-label" }, "New Password", -1)),
                          _createElementVNode("div", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passwordData.value.password) = $event)),
                              class: _normalizeClass([{'is-invalid': _unref(vPassword$).passwordData.password.$error}, "form-control form-control-sm"]),
                              type: "password",
                              name: "new-password"
                            }, null, 2), [
                              [_vModelText, passwordData.value.password]
                            ]),
                            _withDirectives(_createElementVNode("span", _hoisted_26, " Required! ", 512), [
                              [_vShow, _unref(vPassword$).passwordData.password.$invalid]
                            ]),
                            _withDirectives(_createElementVNode("span", { class: "invalid-feedback" }, " The password should have at least " + _toDisplayString(_unref(vPassword$).passwordData.password.minLength.$params.min) + " chars ", 513), [
                              [_vShow, _unref(vPassword$).passwordData.password.minLength.$invalid]
                            ]),
                            _withDirectives(_createElementVNode("span", _hoisted_27, " Required! ", 512), [
                              [_vShow, _unref(vPassword$).passwordData.password.required.$invalid]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "login-form-label" }, "Confirm Password", -1)),
                          _createElementVNode("div", _hoisted_29, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((passwordData.value.confirmPassword) = $event)),
                              class: _normalizeClass([{'is-invalid': _unref(vPassword$).passwordData.confirmPassword.$error}, "form-control form-control-sm"]),
                              type: "password",
                              name: "confirm-password"
                            }, null, 2), [
                              [_vModelText, passwordData.value.confirmPassword]
                            ]),
                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "invalid-feedback" }, " Both values must be equal! ", -1))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "w-100 buttons" }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btnstyle w-100 login-button",
                          onClick: submitPasswordUpdateHandler
                        }, [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                            _createElementVNode("div", { class: "button-text" }, "Update"),
                            _createElementVNode("span", { class: "material-symbols-outlined material-symbols-outlined-400 arrow-icon" }, "arrow_forward")
                          ], -1)
                        ]))])
                      ])
                    ])
                  ], 32))
                : (_openBlock(), _createElementBlock("form", {
                    key: 3,
                    onSubmit: _withModifiers(sendRecoverCodeHandler, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "login-form-label" }, "Please provide the code received by email", -1)),
                          _createElementVNode("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((recoverCodeData.value.code) = $event)),
                              class: _normalizeClass([{'is-invalid': _unref(vCode$).recoverCodeData.code.$error}, "form-control form-control-sm"]),
                              placeholder: "Code",
                              name: "code"
                            }, null, 2), [
                              [_vModelText, recoverCodeData.value.code]
                            ]),
                            _withDirectives(_createElementVNode("span", _hoisted_34, " Required! ", 512), [
                              [_vShow, _unref(vRecover$).recoverData.email.required.$invalid]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "w-100 buttons" }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btnstyle w-100 login-button",
                          onClick: sendRecoverCodeHandler
                        }, [...(_cache[24] || (_cache[24] = [
                          _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                            _createElementVNode("div", { class: "button-text" }, "Send"),
                            _createElementVNode("span", { class: "material-symbols-outlined material-symbols-outlined-400 arrow-icon" }, "arrow_forward")
                          ], -1)
                        ]))])
                      ])
                    ])
                  ], 32))
        ])
      ])
    ])
  ]))
}
}

})